export const projects = [
  {
    image: 'PROJECT_CANA',
    title: 'Monitoreo de cultivos de caña de azúcar',
    description:
      'El proyecto trata de un sistema de monitoreo de sensores en donde se registran y analizan las lecturas de los mismos. Los usuarios pueden ingresar estas mediciones en el programa y enviarlas a una base de datos para su análisis.',
    technologies: ['JAVA', 'POSTGRES', 'SPRINGBOOT', 'JAVASCRIPT'],
    code: 'https://github.com/Jacobo0312/PROYECTO_FINAL-PROG_RED',
    demo: 'https://jacobo0312.github.io/PROYECTO_FINAL-PROG_RED/front/index',
  },
  {
    image: 'PROJECT_SCRABBLE',
    title: 'Simulador de juego Scrabble',
    description:
      'Simulador del juego Scrabble donde podrás armar palabras y ganar puntos con diferentes multiplicadores según la longitud de la palabra. Si quieres probarlo, presiona en la tarjeta.',
    technologies: ['TYPESCRIPT', 'PIXIJS'],
    code: 'https://github.com/Jacobo0312/scrabble-game',
    demo: 'https://jacobo0312.github.io/scrabble-game/',
  },
  {
    image: 'PORTFOLIO',
    title: 'Portafolio profesional',
    description:
      'Este portafolio fue creado con el fin de mostrar mis proyectos y habilidades como desarrollador web. Utilicé React y Tailwind para crearlo.',
    technologies: ['TYPESCRIPT', 'REACT', 'TAILWIND'],
    code: '',
    demo: '',
  },
  {
    image: 'PROJECT_COMPARATOR',
    title: 'Comparador de proyectos financieros en IRR y VPN',
    description:
      'Toma como entrada los flujos de un proyecto y utiliza cálculos matemáticos para calcular la TIR y el VPN. Además, permite comparar varios proyectos entre sí y determinar cuál es el más atractivo en términos de rendimiento financiero.',
    technologies: ['PYTHON'],
    code: 'https://github.com/Jacobo0312/ProjectComparator',
    demo: 'https://github.com/Jacobo0312/ProjectComparator',
  },
];

export const projects2 = [
  {
    image: 'RESTAURANT_MOBILE',
    title: 'Aplicación móvil para restaurantes',
    description:
      'Aplicación móvil para restaurantes, donde los usuarios pueden ver el menú, realizar pedidos y pagar, además de poder ver el estado de su orden. La aplicación fue creada con React Native y se desplegó en iOS y Android.',
    technologies: ['REACT', 'TYPESCRIPT', 'FIREBASE'],
    code: '',
    demo: '',
  },
  {
    image: 'RESTAURANT_DASHBOARD',
    title: 'Aplicación web para restaurantes',
    description:
      'La aplicación de gestión de restaurantes ayuda a administrar eficientemente el negocio, permitiendo ver y crear órdenes, agregar y editar productos y precios, y crear y administrar cuentas de usuario para mejorar la organización y visibilidad de las operaciones del restaurante.',
    technologies: ['REACT', 'JAVASCRIPT', 'FIREBASE'],
    code: '',
    demo: '',
  },
  {
    image: 'RESTAURANT_LANDING',
    title: 'Landing page para restaurante',
    description:
      'La página web promociona un restaurante mostrando sus mejores platos, ubicación y redes sociales. Es una manera de presentar el restaurante a los posibles clientes y brindar información útil sobre su ubicación y presencia en las redes sociales. Presiona en la tarjeta para ver',
    technologies: ['REACT', 'JAVASCRIPT'],
    code: '',
    demo: 'https://weeks-restaurant.web.app/',
  },
  {
    image: 'API_RESTAURANT',
    title: 'API REST para administrar un restaurante',
    description:
      'Es una solución para la administración de un restaurante. Permite a los usuarios realizar operaciones CRUD sobre productos, usuarios, clientes y órdenes. Además, cuenta con características de seguridad para proteger los datos sensibles del restaurante.',
    technologies: ['TYPESCRIPT', 'EXPRESS', 'TYPEORM', 'POSTGRESS', 'FIREBASE'],
    code: '',
    demo: '',
  },
];
